import axios from 'axios';
import { apiUrl } from './constants';
import { logout } from './features/usersSlice';

export const addInterceptors = (store) => {
  axiosApi.interceptors.request.use((config) => {
    const { url } = config;
    const isSignIn = url?.includes('/login');
    if (!isSignIn) {
      const token = store.getState().userState.user.token;
      const headers = config.headers;
      headers.set('Authorization', `Token ${token}`);
    }
    return config;
  });

  axiosApi.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      if (error.response) {
        if (error.response.status === 401) {
          const dispatch = store.dispatch;
          dispatch(logout());
        }
      }
      return Promise.reject(error);
    }
  );
};

const axiosApi = axios.create({
  baseURL: apiUrl,
});

export default axiosApi;
